import { formatCalendarDate, numberToCurrency } from '@/utils'
import type { ReportTableColumn } from '../../stores/types'

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/

// Dates arrive as ISO strings; parse the parts locally so the value
// never shifts a day across timezones. Non-ISO strings pass through.
export function formatIsoDate(value: string): string {
  const isoDay = value.slice(0, 10)
  if (!ISO_DAY.test(isoDay)) return value
  return formatCalendarDate(isoDay)
}

export function formatCell(
  value: unknown,
  format?: ReportTableColumn['format'],
): string {
  if (value === null || value === undefined) return ''
  if (format === 'currency' && typeof value === 'number') {
    return numberToCurrency(value)
  }
  if (format === 'number' && typeof value === 'number') {
    return value.toLocaleString('en-US')
  }
  if (format === 'date' && typeof value === 'string') {
    return formatIsoDate(value)
  }
  return String(value)
}

export function isNumeric(format?: ReportTableColumn['format']): boolean {
  return format === 'currency' || format === 'number'
}
